import { FC, ReactNode } from 'react';

import styles from 'components/common/StickyActionBarWrapper/StickyActionBarWrapper.module.less';

export const StickyActionBarWrapper: FC<{ content: ReactNode; actionBar: ReactNode }> = ({ content, actionBar }) => {
    return (
        <>
            <div className={styles.contentWrapper}>{content}</div>
            {actionBar}
        </>
    );
};
